<div class="timeRangeDiv">
  <glxy-form-field class="timeRangeSelector" [showLabel]="false" bottomSpacing="none">
    <glxy-label>{{ 'LEADERBOARD.TIME_RANGE' | translate }}</glxy-label>
    <mat-select (selectionChange)="setTimeRange($event.value)" [value]="timeRangeOptions[0]">
      @for (option of timeRangeOptions; track option) {
        <mat-option [value]="option">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </glxy-form-field>
  @if ((showCustomDateSelector$$ | async) === true) {
    <glxy-form-field class="custom-date" bottomSpacing="none">
      <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-input [rangePicker]="picker">
        <input
          [formControl]="customRangeStart"
          matStartDate
          placeholder="{{ 'LEADERBOARD.CUSTOM_RANGE.START' | translate }}"
          />
        <input
          [formControl]="customRangeEnd"
          matEndDate
          placeholder="{{ 'LEADERBOARD.CUSTOM_RANGE.END' | translate }}"
          (dateChange)="triggerCustomRangeChanged()"
          />
      </mat-date-range-input>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </glxy-form-field>
  }
</div>
